<template>
  <div class="row">
    <GenericProps
      :node-id="node.id"
      :settings.sync="settings"
      :optional-audio-parameters="optionalAudioParameters"
      :parameters="genericParameters"
      @update:settings="updateNodeParent"
    />

    <template v-for="(param, idx) in specialParameters">
      <div
        :key="idx"
        class="cf-node-properties__field"
        :class="getFieldSize(param.name)"
      >
        <label class="control-label">
          {{ param.displayName }} <span v-if="!param.isOptional">*</span>
          <i
            v-tooltip.top="param.description"
            class="fa fa-question-circle m-l-5"
            aria-hidden="true"
          />
        </label>
        <div class="cf-node-properties__input-wrapper">
          <InputSearchableSelect
            v-if="param.type === 'key' && param.keyType === 'CallPlan'"
            v-model="settings[param.name]"
            :class="{'is-selected': settings[param.name]}"
            :config="callPlanOptions"
            :required="!param.isOptional"
            :error="getFieldError(propertyErrors, param.name)"
            @input="inputChange"
          />
          <button
            v-if="param.type === 'key' && param.keyType === 'CallPlan'"
            type="button"
            class="cf-node-properties__input-action-button"
            @click="triggerGetCallPlans"
          >
            <i
              class="fa fa-refresh"
              :class="{'fa-spin': isLoadingCallPlans }"
              :title="$t('CALL_PLANS_REFRESH')"
            />
          </button>
          <a
            v-if="param.name === 'callPlanId' && settings[param.name]"
            class="cf-node-properties__input-action-link"
            :href="`#/dashboard/callplans/edit/${settings[param.name]}`"
            target="_blank"
          >
            <i
              class="fa fa-external-link"
              :title="$t('CALL_PLANS_VIEW_SELECTED')"
            />
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { merge } from 'lodash';
import messages from '../../../../locales';
import {
  createSettingsHierarchy,
} from '../../../../helpers/node';
import InputSearchableSelect from '../Form/InputSearchableSelect';
import { mapState, mapActions } from 'vuex';
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';

const callPlansConfig = {
  reduce: (option) => option.id,
  label: 'name',
};

export default {
  name: 'DialNodeProps',

  components: {
    InputSearchableSelect,
  },

  mixins: [nodePropsMixin],
  
  data() {
    return {
      selectedWhisperType: 'play',
      optionalAudioParameters: Object.freeze(['whisper']),
      isLoadingCallPlans: false
    };
  },

  computed: {
    ...mapState(['callPlans']),

    callPlanOptions() {
      return {
        options: this.callPlans,
        ...callPlansConfig,
        placeholder: 'Select a Route'
      };
    },

    genericParameters() {
      return this.node.parameters.filter(p => p.type !== 'key' && p.keyType !== 'CallPlan');
    },

    specialParameters() {
      return this.node.parameters.filter(p => p.type === 'key' && p.keyType === 'CallPlan');
    }
  },
  watch: {
    node() {
      this.buildNodeSettings();
    },
  },
  created() {
    this.buildNodeSettings();
  },
  mounted() {
    this.getCallPlans();
  },
  methods: {
    ...mapActions(['getCallPlans']),
    async triggerGetCallPlans() {
      this.isLoadingCallPlans = true;
      await this.getCallPlans();
      setTimeout(() => {
        this.isLoadingCallPlans = false;
      }, 1200);
    },
    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);

      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);

      this.handleWhisper(this.settings.whisper);

      this.updateNodeParent();
    },

    handleWhisper(settings) {
      if (settings.play.URL) {
        settings.isEnabled = true;
        settings.play.isEnabled = true;
      }
      if (settings.say.text) {
        settings.isEnabled = true;
        settings.say.isEnabled = true;
      }
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>